import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";

import { CssIcon } from "styles/helpers/layout";

export const StyledSectionProgressList = styled.ul<Props>`
  list-style: none;
  margin: 0;
  padding: 0;

  width: 100%;
  display: flex;
  row-gap: 0.75rem;
  flex-direction: column;
`;

export interface StyledSectionProgressListItemProps extends Props {
  $isCompleted?: boolean;
}

export const StyledSectionProgressListItem = styled.li<StyledSectionProgressListItemProps>`
  display: grid;
  column-gap: 1rem;
  align-items: center;
  grid-template-columns: auto 1fr 4rem;

  font-size: ${(props: Props) => props.theme.font.size._14};

  > :nth-child(3) {
    text-align: right;
    ${(props: StyledSectionProgressListItemProps) =>
      props.$isCompleted &&
      `
      color: ${props.theme.palette.feedback.success.brand};
    `}
  }

  ${CssIcon} {
    color: ${(props: Props) => props.theme.palette.feedback.success.brand};
  }
`;
